import React from 'react';

import { BettingWidgets } from 'app-constants';
import { PromoMatch } from 'components';
import { useWidgetSettings } from 'hooks';
import { ViewerMode } from '../../constants';
import { StreamProps } from '../../types';
import MatchTracker from '../MatchTracker';
import PinningWrapper from '../PinningWrapper';
import StreamHeader from '../StreamHeader';
import StreamPlayer from '../StreamPlayer';

import './stream.scss';

const MobileStream: React.FC<StreamProps> = ({
    OddButton,
    autoplay,
    backButton,
    betradarId,
    hasMatchLog,
    initPlayer,
    initRef,
    isFullscreenActive,
    isHeaderAtTop,
    isMatchTrackerDisabled,
    isOnMatch,
    isSmall,
    isValidSportId,
    loadScriptStatus,
    matchId,
    onChangeViewerModeToMatchTracker,
    onChangeViewerModeToStream,
    onStreamUnpin,
    onTogglePlayStatus,
    onToggleStreamFullscreen,
    player,
    styleProps,
    title,
    toggleFavoriteButton,
    url,
    viewerMode,
    widthStreamPlayer,
    withPromoMatch,
}) => {
    const {
        pinMinimizedStreamOutOfView,
        disableTheaterMode,
    } = useWidgetSettings({
        widget: BettingWidgets.STREAM,
    });

    const isStreamEnabled = viewerMode === ViewerMode.STREAM && !!url;

    const isBetradarEnabled =
        viewerMode === ViewerMode.MATCH_TRACKER &&
        !isMatchTrackerDisabled &&
        !!betradarId;

    const isContainerShown = isStreamEnabled || isBetradarEnabled;

    const streamComponent = () =>
        isContainerShown ? (
            <div
                styleName="stream-component"
                className="__app-StreamPlayer-stream-component"
                style={{
                    width: !isSmall ? widthStreamPlayer : '100%',
                    height: '100%',
                }}
                ref={initRef}
            >
                {viewerMode === ViewerMode.STREAM && url && (
                    <StreamPlayer
                        url={url}
                        togglePlayStatus={onTogglePlayStatus}
                        initPlayer={initPlayer}
                        autoplay={autoplay}
                        playerNodeId={matchId}
                    />
                )}

                {viewerMode === ViewerMode.MATCH_TRACKER &&
                    !isMatchTrackerDisabled &&
                    betradarId && (
                        <MatchTracker
                            styleProps={styleProps}
                            loadScriptStatus={loadScriptStatus}
                        />
                    )}
            </div>
        ) : null;

    const isHeaderShown = isContainerShown && !isHeaderAtTop && isValidSportId;

    return (
        <React.Fragment>
            {withPromoMatch && (
                <PromoMatch
                    matchId={matchId}
                    OddButton={OddButton}
                    toggleFavoriteButton={toggleFavoriteButton}
                    backButton={backButton}
                    showDynamicScores={isOnMatch}
                    betradarId={betradarId}
                    header={
                        isHeaderShown ? (
                            <StreamHeader
                                betradarId={betradarId}
                                disableTheaterMode={disableTheaterMode}
                                hasMatchLog={hasMatchLog}
                                isFullscreenActive={isFullscreenActive}
                                isMatchTrackerDisabled={isMatchTrackerDisabled}
                                isPinned={false}
                                isValidSportId={isValidSportId}
                                onChangeViewerModeToMatchTracker={
                                    onChangeViewerModeToMatchTracker
                                }
                                onChangeViewerModeToStream={
                                    onChangeViewerModeToStream
                                }
                                onStreamUnpin={() => undefined}
                                onToggleStreamFullscreen={
                                    onToggleStreamFullscreen
                                }
                                title={title}
                                url={url}
                                viewerMode={viewerMode}
                            />
                        ) : null
                    }
                />
            )}
            {pinMinimizedStreamOutOfView &&
            viewerMode !== ViewerMode.MATCH_TRACKER &&
            isContainerShown &&
            !isSmall ? (
                <PinningWrapper
                    matchId={matchId}
                    streamUrl={url}
                    player={player}
                    onStreamUnpin={onStreamUnpin}
                    type="mobile"
                >
                    {streamComponent}
                </PinningWrapper>
            ) : (
                streamComponent()
            )}
        </React.Fragment>
    );
};

export default MobileStream;
